import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';
import moment from 'moment';
import emotionFirstChildSelector from '@/lib/styling/emotionFirstChildSelector';

const StyledDate = styled('span')(({ theme }) => ({
  marginBottom: 0,
  marginLeft: 12,
  color: theme.palette.text.secondary,
  fontWeight: 400,
  fontSize: 15,
  lineHeight: 1,
  ':first-letter': {
    textTransform: 'uppercase',
  },
  [emotionFirstChildSelector]: {
    marginLeft: 0,
  },
  [mediaQuery(1024)]: {
    marginLeft: 0,
    fontSize: 14,
  },
}));

type CommentCreatedAtProps = {
  createdAt: string;
};

const CommentCreatedAt = ({ createdAt }: CommentCreatedAtProps) => (
  <StyledDate>{moment(createdAt).calendar({ lastWeek: 'L' })}</StyledDate>
);

export default CommentCreatedAt;
